export const ENTRY_LABELS = {
  DEBIT: "Debit",
  REVERSAL: "Reversal",
  ADJUSTMENT: "Adjustment",
};
